<template>

  <FatturazioneGas />

</template>

<script>
import FatturazioneGas from '../components/fatturazione/FatturazioneGas.vue'

export default {
  pageName: 'FatturazioneGas',
  components: {
    FatturazioneGas

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
